var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 54h47a16 16 0 0 0 0-32 24 24 0 0 0-45-7A20 20 0 0 0 24 54z",
    fill: "#dce8f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54h47a16 16 0 0 0 0-32 24 24 0 0 0-45-7A20 20 0 0 0 24 54z",
    fill: "none",
    stroke: "#9db5c7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4aa3df"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 72,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 80,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 72,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowers);
export default __webpack_public_path__ + "static/media/showers.144705dad5b8bc94c6ce1f3af770299b.svg";
export { ForwardRef as ReactComponent };